import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const ContentListQuestions = ({ data, botImage, onClick }) => (
  <div className="content-questions">
    <img src={botImage} className="content-image-bot" alt="avatar" />
    <div className="content-list">
      {data.suggestedActions.map((response) => (
        <button
          type="button"
          onClick={() => onClick(response.value)}
          className="content-list-bot"
        >
          {response.title}
        </button>
      ))}
    </div>
  </div>
);

ContentListQuestions.propTypes = {
  data: PropTypes.array.isRequired,
  botImage: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ContentListQuestions;
